<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

        <!-- <v-dialog persistent
          v-model="dialog"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Create new
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
              <contest-form 
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="getBackData"
              @closed="closeModal"/>
            <v-divider/>
        
          </v-card>
        </v-dialog> -->

      <v-layout justify-center wrap v-if="contestDetails">


      <v-flex
        xs12
        md12
        
      >
        <material-card
          color="green"
          :title="contestDetails.question"
        >
        
          
      <v-layout wrap>

      <v-flex
        xs12
        md6
      >

      <p :class="contestDetails.correct_answer === 1 ? 'green--text': ''"> <b>A: </b> {{contestDetails.option1}} </p>
      <p :class="contestDetails.correct_answer === 2 ? 'green--text': ''"> <b>B: </b> {{contestDetails.option2}} </p>
      <p :class="contestDetails.correct_answer === 3 ? 'green--text': ''"> <b>C: </b> {{contestDetails.option3}} </p>
      <p :class="contestDetails.correct_answer === 4 ? 'green--text': ''"> <b>D: </b> {{contestDetails.option4}} </p>

      <v-divider></v-divider>
      <p> <b>Prize amount: </b> {{contestDetails.prize_amount}} BDT</p>
      <v-divider></v-divider>
      <p> <b>Contest Date: </b> {{contestDetails.contest_date}}</p>
      <v-divider v-if="contestDetails.winner === null"></v-divider>

      <v-btn v-if="contestDetails.winner === null" color="success" @click="createWinner">
        Select a random winner
      </v-btn>
      </v-flex>



      <v-flex xs12 md6 v-if="contestDetails.winner">
        <v-layout>
          <v-flex xs12 md6 >
            <h3 style="text-center">Winner </h3>
            <v-divider></v-divider>
            <img :src="'https://api.bacbonschool.com/uploads/userImages/' + contestDetails.winner.image" height="100" contain/>
            <v-divider></v-divider>
            <b>{{ contestDetails.winner.name }} </b>
          </v-flex>

          <v-flex xs12 md6 >
            <template v-if="contestDetails.winner.winner_cover_image">

              <img  :src="contestDetails.winner.winner_cover_image" height="100" contain/>
                 <v-btn
                  fab
                  dark
                  small
                  color="red"
                  @click="deleteCoverImage(contestDetails.winner.id)"
                >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-divider ></v-divider>

            </template>
            <template v-if="contestDetails.winner.winner_cover_image === null"> 
              
              <v-text-field  v-model="coverBanner" label="Cover Photo" @click='pickCoverImage' prepend-icon='attach_file' class="green-input"></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="coverImage"
                  accept="image/*"
                  @change="onCoverImagePicked($event, contestDetails.winner.id)"
                >
                <v-btn color="success" @click="uploadCoverImage">
                  Submit
                </v-btn>
            </template>
               
            </v-flex>
            </v-layout>
          </v-flex>


      <v-flex
        xs12
        md6
      >
      </v-flex>
      </v-layout>
        </material-card>

      </v-flex>
      <v-flex
        xs12
        md6
      >
        <material-card color="green" title="Correct answerer list">
          <v-data-table :headers="headers" :items="contestDetails.correct_answers">
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> 

                <v-img v-if="item.image"
                    :src="'https://api.bacbonschool.com/uploads/userImages/' + item.image"
                    height="34"
                    contain
                  />
            </td>
              <td> 
            <v-icon v-if="item.is_winner" color="yellow text--darken-4">mdi-trophy</v-icon> {{ item.name }}</td>
              <td >{{ item.given_answer === 1 ? contestDetails.option1 : item.given_answer === 2 ? contestDetails.option2 : item.given_answer === 3 ? contestDetails.option3 : contestDetails.option4  }}</td>
              <td>
                
              </td>
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
      <v-flex
        xs12
        md6
      >
        <material-card
          color="green"
          title="Wrong answerer list"
        >
        
     
          <v-data-table :headers="wrongAnswerHeaders" :items="contestDetails.wrong_answers">
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td> 

                <v-img v-if="item.image"
                    :src="'https://api.bacbonschool.com/uploads/userImages/' + item.image"
                    height="34"
                    contain
                  />
            </td>
              <td>  {{ item.name }}</td>
              <td >{{ item.given_answer === 1 ? contestDetails.option1 : item.given_answer === 2 ? contestDetails.option2 : item.given_answer === 3 ? contestDetails.option3 : contestDetails.option4  }}</td>
              <td>
                
              </td>
            </template>
          </v-data-table>

        </material-card>

      </v-flex>
    </v-layout>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Form from '@/views/Form'
export default {
  components: {
    Form
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('dailyQuiz', ['contestDetails']),
  },
  mounted () {
    this.getContestDetails(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    coverImage: {},
    coverBanner: null,
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      wrongAnswerHeaders: [
      {
        sortable: false,
        text: 'Avatar',
        value: 'image'
      },
      {
        sortable: true,
        text: 'Name',
        value: 'name'
      },
      {
        sortable: false,
        text: 'Given Answer',
        value: ''
      }
    ],    
    headers: [
      {
        sortable: false,
        text: 'Avatar',
        value: 'image'
      },
      {
        sortable: true,
        text: 'Name',
        value: 'name'
      },
      {
        sortable: false,
        text: 'Given Answer',
        value: ''
      },
      {
        sortable: false,
        text: 'Action',
        value: ''
      }
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'New Contest',
        'subTitle': 'Create daily quiz for contest',
        'submitText' : 'Submit'
      },
      valueObj: {},
      inputFields: [
        {
          label: 'Question',
          width: 'md12',
          type: 'text',
          isEnable: true,
          name: 'question',
          formName: 'Question',
          nameRules: [
            v => !!v || 'Question is required'
          ]
        },
        {
          label: 'Option 1',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option1',
          formName: 'Option1',
          nameRules: [
            v => !!v || 'Option 1 is required'
          ]
        },
        {
          label: 'Option 2',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option2',
          formName: 'Option 2',
          nameRules: [
            v => !!v || 'Option 2 is required'
          ]
        },
        {
          label: 'Option 3',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option3',
          formName: 'Option 3',
          nameRules: [
            v => !!v || 'Option 3 is required'
          ]
        },
        {
          label: 'Option 4',
          width: 'md6',
          type: 'text',
          isEnable: true,
          name: 'option4',
          formName: 'Option 4',
          nameRules: [
            v => !!v || 'Option 4 is required'
          ]
        }
       
      ]
    }
  },
  created () {
  },
  methods: {
    ...mapActions("dailyQuiz", ["getContestDetails",
    "createWinnerDailyQuiz",
    "uploadContestWinnerBanner", "deleteCoverImageDailyQuiz"]),

    getBackData (data) {
          this.color = data.status === "OK" ? "success": "warning"
          if (data.status === "OK") {
            this.noticeMessage = "Success! " + data.messages;
            this.dialog = false
          } else {
            this.noticeMessage = "Warning! " + data.messages;
          }
          this.snack("top");
    },
    closeModal () {
      this.dialog = false
    },
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }
      this.snackbar = true
    },
    pickCoverImage () {
      this.$refs.coverImage.click()     
    },
	  onCoverImagePicked (event, id) {
      let fileName = this.$refs.coverImage.files[0].name;
      this.coverImage.id = id
      this.coverImage.name = fileName
      this.coverBanner = fileName
      this.coverImage.ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.coverImage.file = reader.result.split(',')[1]
      }
 
   },
   async uploadCoverImage () {
      const response = await this.uploadContestWinnerBanner(this.coverImage)
      this.color = response.status === "OK" ? "success": "warning"
      if (response.status === "OK") {
        this.noticeMessage = "Success! " + response.messages;
        this.dialog = false
        this.getContestDetails(this.$route.params.id)
      } else {
        this.noticeMessage = "Warning! " + response.messages;
      }
      this.snack("top");
   },
   async deleteCoverImage (id) {
     let data = {
       id : id
     }
    const response = await this.deleteCoverImageDailyQuiz(data)
    this.color = response.status === "OK" ? "success": "warning"
      if (response.status === "OK") {
        this.noticeMessage = "Success! " + response.messages;
        this.dialog = false
        this.getContestDetails(this.$route.params.id)
      } else {
        this.noticeMessage = "Warning! " + response.messages;
      }
      this.snack("top");
   },
   async createWinner (id) {
     let data = {
       id : id
     }
    const response = await this.createWinnerDailyQuiz(data)
    this.color = response.status === "OK" ? "success": "warning"
      if (response.status === "OK") {
        this.noticeMessage = "Success! " + response.messages;
        this.dialog = false
        this.getContestDetails(this.$route.params.id)
      } else {
        this.noticeMessage = "Warning! " + response.messages;
      }
      this.snack("top");
   }

  }
}
</script>